/* 
 * Facet mixins for 
 */

define([],
    function(){
        var FacetMixin = {
            /**
             * Facets object:
             * {
             *   "GT02-356" : 365,
             *   "GT03-2355" : 1209
             * }
             */
            _facets: [],
            
            /**
             * Applys the facet-data to an object (Widget for example)
             * @param {object} facetObject A facet object, exampe: 
             * {
             *      "globalType" : {
             *          "GT02-356" : 365,
             *          "GT03-2355" : 1209
             *      },
             *      "board" : {
             *          "FB" : 450
             *      }
             * }
             */
            setFacets : function(facetObject){
                throw new Error("Required method setFacets not implemented");
            },
            
            /**
             * Returns an object with all faceted data
             * For example
             * {
             *      "globalType" : {
             *          "GT02-356" : 365,
             *          "GT03-2355" : 1209
             *      },
             *      "board" : {
             *          "FB" : 450
             *      }
             * }
             * @returns {object}
             */
            getFacets : function(){
                throw new Error("Required method getFacets not implemented");
            },
            
            /**
             * Override the setFacets() method and call this method.
             * This method expects the each of globalTypeElements has data-value="GT03-XXX" 
             * attribute set.
             * 
             * 
             * @param {String} globalTypeElements All global type elements
             * @param {String} facetsCountElementSelector Selector for counter
             * @returns {undefined}
             */
            _setFacetsCounts: function(globalTypeElements, facetsCountElementSelector) {
                var self = this;
                globalTypeElements.each(function(index, gtElement) {
                    gtElement = $(gtElement);
                    var currentGt = gtElement.data('value');
                    // _setFacetsCountForElement() comes from FacetsMixin
                    var count = 0;
                    if(_.has(self._facets, currentGt)) {
                        count = self._facets[currentGt];
                    }
                    $(facetsCountElementSelector, gtElement).text(count);
                    
                    if(count === 0) {
                        self._disableThroughFacets(gtElement);
                    }
                });
            },
            
            /**
             * Adds a class to show a zero/disalbed state of an element
             * 
             * @param {type} element
             * @returns {undefined}
             */
            _disableThroughFacets: function(element) {
                element.addClass('disabled');
            }
        };
        
        return FacetMixin;
    }
);


//////////////////
// WEBPACK FOOTER
// ./~/fcse-facets/facetsMixin.js
// module id = 162
// module chunks = 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21